import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};

  > div {
    @media screen and (max-width: 800px) {
      max-width: 85vw;
    }
  }
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: ${props => props.theme.spacing.sp16};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-top: ${props => props.theme.spacing.sp16};
`

export const TransactionsContainer = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
`
